import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Passport from "@/components/Passport";
import Nations from "@/components/Nations";
import YouthParliament from "@/components/YouthParliament";
import Manifesto from "@/components/Manifesto";
import JoinMovement from "@/components/JoinMovement";
import Gazette from "@/components/Gazette";
import Footer from "@/components/Footer";
import AdminDesk from "@/pages/AdminDesk";
import CharterPage from "@/pages/CharterPage";

function Home() {
  return (
    <div className="bg-[#0A0C0E] text-[#F7F5F0] min-h-screen overflow-x-clip" data-testid="usa-app">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Passport />
        <Nations />
        <YouthParliament />
        <Manifesto />
        <JoinMovement />
        <Gazette />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-[#0A0C0E] text-[#F7F5F0] min-h-screen">
      <Toaster position="top-center" theme="dark" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDesk />} />
          <Route path="/charter" element={<CharterPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
